import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
import ScrollIndicator from './ScrollIndicator';

const Hero = () => {
  const [isMobile, setIsMobile] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Force play the video when component mounts or when screen mode changes
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.defaultMuted = true;
      videoRef.current.muted = true;
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.log("Autoplay was prevented or video failed to load:", error);
        });
      }
    }
  }, [isMobile]);

  const handleTimeUpdate = (e) => {
    if (e.target.currentTime >= 8.0) {
      e.target.currentTime = 0;
    }
  };

  return (
    <section className="hero">
      <div className="hero-video-container hero-animate-down">
        {isMobile ? (
          <video
            ref={videoRef}
            key="mobile-video"
            autoPlay
            loop
            muted
            defaultMuted
            playsInline
            className="hero-video"
            poster="https://caninecrown.ascentbw.com/Image/HeroPoster.webp"
            onTimeUpdate={handleTimeUpdate}
          >
            <source src="https://caninecrown.ascentbw.com/Image/HeroMobVideo1.mp4" type="video/mp4" />
            <track kind="captions" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <video
            ref={videoRef}
            key="desktop-video"
            autoPlay
            loop
            muted
            defaultMuted
            playsInline
            className="hero-video"
            poster="https://caninecrown.ascentbw.com/Image/HeroPoster.webp"
            onTimeUpdate={handleTimeUpdate}
          >
            <source src="https://caninecrown.ascentbw.com/Image/VideoHero1.mp4" type="video/mp4" />
            <track kind="captions" />
            Your browser does not support the video tag.
          </video>
        )}
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content container">
        <div className="hero-left hero-animate-up">
          <h1 className="hero-title1">
            Premium   Nutrition <br className="desktop-br" />
            For Healthier,<br className="desktop-br" />
            Happier Pets
          </h1>
          <p className="hero-description">
            Scientifically formulated pet food made with<br />
            high-quality ingredients to support strength,<br />
            immunity, and overall wellbeing.
          </p>
          <div className="hero-actions">
            <Link to="/products" className="btn btn-outline">Explore Products</Link>
          </div>
        </div>
      </div>

      <ScrollIndicator />
    </section>
  );
};

export default Hero;
